// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.play-item:hover {
    background-color: rgb(248, 245, 245);
}

.play-item {
    margin: 8px;
    cursor: pointer;
    padding: 6px;
    border-radius: 16px;
}
.not-showing {
    margin: 8px;
    cursor: pointer;
    padding: 6px;
    border-radius: 16px;
    cursor: none !important;
    color: grey;
    background-color: grey;
}

.selected {
    background-color: rgb(233, 228, 228);
}
.css-2n9k1h-MuiFormControl-root {
    width: 90% !important;
}
`, "",{"version":3,"sources":["webpack://./src/component/PlayPageComponent/PlayItem/PlayItem.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;AACxC;AACA;IACI,qBAAqB;AACzB","sourcesContent":[".play-item:hover {\r\n    background-color: rgb(248, 245, 245);\r\n}\r\n\r\n.play-item {\r\n    margin: 8px;\r\n    cursor: pointer;\r\n    padding: 6px;\r\n    border-radius: 16px;\r\n}\r\n.not-showing {\r\n    margin: 8px;\r\n    cursor: pointer;\r\n    padding: 6px;\r\n    border-radius: 16px;\r\n    cursor: none !important;\r\n    color: grey;\r\n    background-color: grey;\r\n}\r\n\r\n.selected {\r\n    background-color: rgb(233, 228, 228);\r\n}\r\n.css-2n9k1h-MuiFormControl-root {\r\n    width: 90% !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
